angular.module('autoremind.reports.filters', [])
    .filter('todoDataFilter', [function () {
        return function (data) {
            return '';
        };
    }])
    .filter('imageByConfigType', [function () {
        return function (type) {
            var src = '';
            switch (type) {
                case 'personal':
                    src = '../../img/gcons/ID.png';
                    break;
                case 'business':
                    src = '../../img/dollar.png';
                    break;
                default:
                    src = '../../img/gcons/ID.png';
            }
            return src;
        };
    }])
    .filter('patientsTasksByCurrentDate', ['todoService', function (todoService) {
        return function (data) {
            //console.log(data[todoService.chosenDateShort], todoService.chosenDateShort);
            return (data[todoService.chosenDateShort] && data[todoService.chosenDateShort].patients) ? data[todoService.chosenDateShort].patients : [];
        };
    }])
    .filter('otherTasksByCurrentDate', ['todoService', function (todoService) {
        return function (data) {
            //console.log(data[todoService.chosenDateShort], todoService.chosenDateShort);
            return (data[todoService.chosenDateShort] && data[todoService.chosenDateShort].other) ? data[todoService.chosenDateShort].other : [];
        };
    }])
    .filter('countNotDoneTasksByCurrentDate', ['todoService', function (todoService) {
        return function (data, type) {
            switch (type) {
                case 'other':
                    return (data[todoService.chosenDateShort] && data[todoService.chosenDateShort].countNotDoneOther) ? data[todoService.chosenDateShort].countNotDoneOther : 0;
                    break;
                case 'business':
                    return (data[todoService.chosenDateShort] && data[todoService.chosenDateShort].countNotDoneBusiness) ? data[todoService.chosenDateShort].countNotDoneBusiness : 0;
                    break;
                default:
                    return (data[todoService.chosenDateShort] && data[todoService.chosenDateShort].countNotDoneTasks) ? data[todoService.chosenDateShort].countNotDoneTasks : 0;
            }
            //console.log(data[todoService.chosenDateShort], todoService.chosenDateShort);
        };
    }])
    .filter('strToTime', function () {
    return function (str) {
        var hours = Number(str.match(/^(\d+)/)[1]);
        var minutes = Number(str.match(/:(\d+)/)[1]);
        var AMPM = 'AM';
        if (hours > 12 || hours === 12 && minutes > 0) {
            hours -= 12;
            AMPM = 'PM';
        }
        else if (hours === 0 && minutes === 0) {
            AMPM = 'PM';
        }
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10)
            sHours = "0" + sHours;
        if (minutes < 10)
            sMinutes = "0" + sMinutes;
        return sHours + ":" + sMinutes + " " + AMPM;
    };
});
//# sourceMappingURL=todo.filters.js.map